import React from "react";
import MenuGroup from "./MenuGroup";
import ProfileMenu from "./ProfileMenu";
import VersionInfo from "./VersionInfo";
import "./AppHeader.css";
import "./MenuGroup.scss";
import {getAccessibleWarehouseIds, getDashboards} from "../reducers/authReducer";
import {connect} from "react-redux";
import {getWarehouseLabelFromId} from "../lib/WarehouseHelper";


const AppHeader = (props) => {
  if (!props.authenticated) {
    return null;
  }

  return (
    <div className="AppHeader">
      <div className="actions">
        { buildDashboardMenus(props.allDashboards, props.currentPath) }
        <MenuGroup currentPath={props.currentPath} label="Inventory" show={props.canReadInventory}
          links={[
            { to: "/inventory/water-pallets", label: "Water Pallets" },
            { to: "/inventory/other-pallets", label: "Other Pallets" },
            { to: "/warehouses", label: "Warehouses" },
            { to: "/products", label: "Products" },
            { to: "/stock", label: "Stock Control" },
            // Optionnal pages allowing to list jobs for each warehouse the
            // user has the right to access.
            ...props.accessibleWarehouseIds.map((id) =>
              ({ to: "/inventory/jobs/" + id + "?active=true", label: getWarehouseLabelFromId(id) + " Jobs" })
            ).toJS(),
          ]} />
        <MenuGroup currentPath={props.currentPath} label="Shipping" show={props.canReadShipping}
          links={[
            { to: "/distribution", label: "Distribution" },
            { to: "/shipping/orders", label: "Shipping Orders" },
            { to: "/shipping/edi", label: "Incoming EDI Queue" },
            { to: "/shipping/product-distribution", label: "Product Report" },
            { to: "/shipping/preferred-courier-services", label: "Preferred Courier Services" },
          ]} />
        <MenuGroup currentPath={props.currentPath} label="Sales" show={props.canReadSales}
          links={[
            { to: "/shops", label: "Shops" },
            { to: "/customers", label: "Customers" },
            { to: "/sales/orders", label: "Orders" },
            { to: "/sales/metaOrders", label: "Meta Orders" },
            { to: "/subscriptions", label: "Subscriptions" },
            { to: "/subscriptions/upcoming", label: "Upcoming Deliveries" },
            { to: "/sales/promo-codes", label: "Promo Codes" },
            { to: "/referral-codes", label: "Referral Codes" },
            { to: "/product-waiting-list", label: "Product Waiting List" },
          ]} />
        <MenuGroup currentPath={props.currentPath} label="Other" show={props.canReadNotes}
          links={[
            { to: "/notes", label: "Notes" }
          ]} />
        <MenuGroup currentPath={props.currentPath} label="Management" show={props.canReadAdmin}
          links={[
            { to: "/users", label: "Users" },
            { to: "/onboarding/migrations", label: "Migrations" },
          ]} />
        <MenuGroup currentPath={props.currentPath} label="Settings" show={props.canReadAdmin}
          links={[
            { to: "/settings/us_taxes", label: "Us Tax" },
            { to: "/settings/services", label: "Services" },
          ]} />
      </div>
      <div className="actions">
        <ProfileMenu
          onLogout={props.onLogout} />
        <VersionInfo 
          right={true} />
      </div>
    </div>
  );
}

// There can be N dashboard menus, each containing a title and a list of links
function buildDashboardMenus(allDashboards, currentPath) {
  return allDashboards.map(({title, links: dashboardLinks}) => {
    if (dashboardLinks.length === 0) {
      // Nothing to display
    } else if (dashboardLinks.length === 1) {
      const dashboard = dashboardLinks[0];
      return <MenuGroup key={dashboard.label} currentPath={currentPath} links={[{
        to: dashboard.to || "/",
        className: "dashboardLink",
        label: dashboard.label || "Dashboard",
      }]} />
    } else {
      return (
        <MenuGroup key={title} currentPath={currentPath} label={title || "Dashboards"}
          links={ dashboardLinks.map((d) => ({ to: d.to, className: "dashboardLink", label: d.label })) } />
      );
    }
  });
}

function mapStateToProps(state) {
  return {
    allDashboards: getDashboards(state.get("auth")),
    accessibleWarehouseIds: getAccessibleWarehouseIds(state.get("auth")),
  }
}

export default connect(mapStateToProps)(AppHeader);
